import { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import PostCard from "../components/PostCard";
import { api } from "../lib/api";
import { Bookmark } from "lucide-react";

/**
 * Saved posts page (`/saved`). Lists every post the current user has
 * bookmarked via the 3-dot menu's "Save post" action.
 */
export default function Saved() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/posts/saved");
      setPosts(data);
    } catch { /* noop */ }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <Layout>
      <div className="space-y-6" data-testid="saved-page">
        <div>
          <div className="label-mystic flex items-center gap-2">
            <Bookmark size={12} strokeWidth={1.5} /> Library
          </div>
          <h1 className="font-serif text-5xl mt-2">Saved Posts</h1>
          <p className="text-sm text-foreground/65 mt-2 max-w-xl">
            Posts you've bookmarked from the feed. Tap the three-dot menu on any post and choose <em>Save</em> to add it here.
          </p>
        </div>

        {loading ? (
          <div className="parchment p-12 text-center font-serif text-2xl text-foreground/60">Loading…</div>
        ) : posts.length === 0 ? (
          <div className="parchment p-12 text-center" data-testid="saved-empty">
            <Bookmark size={28} strokeWidth={1.25} className="mx-auto text-secondary/60 mb-3" />
            <div className="font-serif text-2xl text-foreground/75 mb-1">Nothing saved yet</div>
            <p className="text-sm text-foreground/55">
              When you find a post worth keeping, save it here for later.
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {posts.map((p) => (
              <PostCard
                key={p.id}
                post={p}
                onUpdate={(np) => setPosts((arr) => arr.map((x) => x.id === np.id ? np : x))}
                onRemove={(pid) => setPosts((arr) => arr.filter((x) => x.id !== pid))}
              />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
